import clsx from 'clsx';
import React from 'react';
import './PaymentMethodBase.scss';
const PaymentMethodBase = ({ children, className, input, variant }) => (React.createElement("div", { className: clsx('payment_method', `payment_method--${variant}-style`, className, {
        'payment_method--input-disabled': input?.disabled,
    }) }, children));
export default PaymentMethodBase;
